"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const authenticator_1 = require("../../authenticator");
const session_1 = require("../../session");
const storage_1 = require("../../session/cc/storage");
const store_1 = require("../../store");
const features_1 = require("../../features");
const features_2 = require("../../features");
const configureFramework = (bankId, language, additionalPlugins = []) => {
    const Session = new session_1.MbDRPicasoSession(new storage_1.MbCCSessionStorage((0, store_1.getDefaultCookiesStore)()));
    //TODO Session needs XHR Authplugin and this plugin needs session
    const plugins = [...additionalPlugins, new features_2.XHRAcceptLanguagePlugin(language), new features_2.XHRBankIdPlugin(bankId)];
    Session.setXHR(new features_2.XHR({
        plugins,
    }));
    const AuthApi = new features_2.XHR({
        plugins: [...additionalPlugins],
    });
    const helper = new features_1.AssistedCCHelper(AuthApi);
    const Authenticator = new authenticator_1.MbDRPicasoAuthenticator(Session, AuthApi, helper);
    const MockUsdManager = new features_1.MockUSDManager();
    return {
        Session,
        Authenticator,
        MockUsdManager,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map